module.exports = __webpack_public_path__ + "static/media/wavm8s-012-cralias.be2eba2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-012-cralias.mp3
// module id = Kee2
// module chunks = 0